'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var constants = require('../../constants.js');
var ui = require('../../../popup/v1/ui.js');
var ui$1 = require('../../../paragraph/ui.js');
var ui$2 = require('../../../form/v4/ui.js');
var ui$3 = require('../../../button/v2/ui.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const CheckoutPopup = ({
  open,
  setOpen,
  onFinish,
  loading
}) => {
  return /* @__PURE__ */ jsxRuntime.jsxs(ui.PopupV1, __spreadProps(__spreadValues({
    show: open,
    onFinishClose: () => !loading && setOpen(false)
  }, {
    maskClosable: true,
    showCloseIcon: true,
    closeIcon: {
      size: 24
    },
    closeIconWrapperStyle: {
      top: 16,
      right: 16
    },
    maskStyle: {
      backgroundColor: "rgba(0, 0, 0, 0.5)"
    },
    commonStyle: {
      borderRadius: 8,
      width: 334,
      backgroundColor: "#fff",
      padding: {
        left: 24,
        right: 24,
        bottom: 16,
        top: 16
      }
    },
    position: "default"
  }), {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(ui$1.Paragraph, {
        text: "T\u1EA1o \u0111\u01A1n h\xE0ng",
        commonStyle: {
          fontSize: 16,
          lineHeight: "24px",
          fontWeight: "bold",
          margin: { bottom: 4 }
        }
      }),
      /* @__PURE__ */ jsxRuntime.jsx(ui$2.FormV4, {
        labelStyle: {
          margin: { top: 12 }
        },
        inputs: constants.inputsConfig,
        submits: [],
        hiddenFields: [],
        showLabel: true,
        onFinish,
        customLoading: loading,
        children: /* @__PURE__ */ jsxRuntime.jsx(ui$3.ButtonV2, {
          text: "T\u1EA1o \u0111\u01A1n",
          buttonStyle: {
            backgroundColor: "#7367F0",
            color: "rgba(255, 255, 255, 1)",
            height: 32,
            width: 83,
            borderRadius: 4
          },
          commonStyle: { justifyContent: "flex-end", margin: { top: 12 } }
        })
      })
    ]
  }));
};

exports.CheckoutPopup = CheckoutPopup;
